module.exports = __webpack_public_path__ + "static/img/whitebg.736e485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whitebg.png
// module id = QOmd
// module chunks = 1